import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
//import { BlogEntry, BlogEntryComment } from './blogEntry';
import * as BlogNS from "./blogEntry";
import { Observable } from "rxjs";

@Injectable()
export class DataService {

    private token: string = "";
    private tokenExpiration: Date;

    public blogEntries: BlogNS.BlogEntry[] = [];

    public get loginRequired(): boolean {
        return this.token.length == 0 || this.tokenExpiration < new Date();
    }

    constructor(private httpClient: HttpClient) {

    }

    loadBlogEntries(): Observable<boolean> {
        return this.httpClient.get("api/blog")
            .pipe(
                map((data: any[]) => {
                    this.blogEntries = data;
                    return true;
                })
            );
    }

    login(credentials): Observable<boolean> {
        return this.httpClient
            .post("/account/createtoken", credentials)
            .pipe(
                map((response: any) => {
                    this.token = response.token;
                    this.tokenExpiration = response.expiration;
                    return true;
                }));
    }

    public addBlogEntry(blogEntry: BlogNS.BlogEntry) {
        return this.httpClient
            .post("/api/blog", blogEntry, {
                headers: new HttpHeaders()
                    .set("Authorization", "Bearer " + this.token)
            })
            .pipe(
                map((response: any) => {
                    return true;
                }));
    }

    public addBlogComment(blogEntryComment: BlogNS.BlogEntryComment) {
        let blogEntry = this.blogEntries.find(p => p.id === blogEntryComment.entityId);

        if (blogEntry) {
            blogEntry.blogEntryComments.push(blogEntryComment);
        }
        else {
            // return error
        }
    }
}